// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2222":"f49c124f","2289":"d25ec183","2503":"dabb2ccd","4573":"33e44baa","6917":"334653f2"}[chunkId] + ".chunk.css";
};